import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../../boot";
import { XMLParser } from "fast-xml-parser";
import { toast } from "react-toastify";
import { externalFetcher } from "../helper/externalApiFetch";
const options = {
    ignoreAttributes: false,
    attributeNamePrefix: "@_",
    parseAttributeValue: false,
    parseTagValue: false,
};
const parser = new XMLParser(options);

export const getYearDataAPi = createAsyncThunk("/lookup=year", async (_, { rejectWithValue }) => {
    // try {
    //     const response = await externalFetcher(`https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=year&id=VAP0204`);
    //     const jsonData = parser.parse(response);
    //     console.log(" this is year resp  resonse ", jsonData);
    //     return jsonData;
    // } catch (error) {
    //     throw error;
    // }
    const token = localStorage.getItem("authToken");
    let url = `${baseUrl}vancouverapis/admin/showmetheparts/api/v1/get-part?lookup=year`
    try {
        const response = await axios.get(url, {
            headers: {
                "auth-token": token,
            },
        });
        const yearData = response.data?.years.map(
            (year) => ({
                value: year.id,
                label: year.id,
            })
        );
        return yearData; // ✅ Return only the data
    } catch (error) {
        console.error("Error fetching Years:", error);

        // ✅ Handle errors properly
        return rejectWithValue(error.response?.data?.message || "error in fetching Years list");
    }
});

// make data api

export const getMakeDataAPi = async (year) => {
    //     try {
    //         const response = await externalFetcher(`https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=make&year=${year}&id=
    // VAP0204`);
    //         console.log(" this is make resp  resonse ", response);
    //         const jsonData = parser.parse(response);
    //         console.log(" this is make jsonData  ", jsonData);
    //         return jsonData;
    //     } catch (error) {
    //         throw error;
    //     }
    const token = localStorage.getItem("authToken");
    let url = `${baseUrl}vancouverapis/admin/showmetheparts/api/v1/get-part?year=${year}`
    try {
        const response = await axios.get(url, {
            headers: {
                "auth-token": token,
            },
        });

        const makeData = response.data?.makes.map(
            (make) => ({
                value: make.id,
                label: make.data,
            })
        );
        return makeData; 
    } catch (error) {
        console.error("Error fetching Makes:", error);

        // ✅ Handle errors properly
        return (error.response?.data?.message || "error in fetching Makes list");
    }
}

// model data api
export const getModelDataAPi = async (data,) => {
    // try {
    //     // console.log(" this is make year  ", data.selectedMake, data.selectedYear);
    //     const response = await externalFetcher(`https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=model&year=${data.selectedYear}&make=${data.selectedMake}&id=VAP0204`);
    //     console.log("url ", `https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=model&year=${data.selectedYear}&make=${data.selectedMake}&id=VAP0204`);

    //     // console.log(" this is model resp  resonse ", response);
    //     const jsonData = parser.parse(response);
    //     if (jsonData.ShowMeTheParts_Model.model.id === "") {
    //         toast.error("Model data not found");
    //     }
    //     console.log(" this is model jsonData  ", jsonData);
    //     return jsonData;
    // } catch (error) {
    //     throw error;
    // }
    const token = localStorage.getItem("authToken");
    let url = `${baseUrl}vancouverapis/admin/showmetheparts/api/v1/get-part?year=${data.selectedYear}&make=${data.selectedMake}`
    try {
        const response = await axios.get(url, {
            headers: {
                "auth-token": token,
            },
        });
        const modelData = response.data?.models.map(
            (model) => ({
                value: model.id,
                label: model.data,
            })
        );
        return modelData; // ✅ Return only the data
    } catch (error) {
        console.error("Error fetching Makes:", error);

        // ✅ Handle errors properly
        return (error.response?.data?.message || "error in fetching Makes list");
    }
}

// product lookup ---------->(Part type)

export const getProductDataAPi = async (data) => {
    // try {
    //     const response = await externalFetcher(`https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=parttype&year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}&id=VAP0204`);
    //     console.log(`https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=parttype&year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}&id=VAP0204`)
    //     console.log(" this is product resp  resonse ", response);
    //     const jsonData = parser.parse(response);
    //     console.log(" this is product jsonData  ", jsonData);
    //     return jsonData;
    // } catch (error) {
    //     throw error;
    // }
    const token = localStorage.getItem("authToken");
    // let url = `${baseUrl}vancouverapis/admin/showmetheparts/api/v1/get-part?year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}`
    let url = `${baseUrl}vancouverapis/admin/showmetheparts/api/v1/get-parttypes?year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}`
    try {
        const response = await axios.get(url, {
            headers: {
                "auth-token": token,
            },
        });
        // const partTypeData = response.data?.partType.map((part) => ({
        //     value: part.id,
        //     label: part.data,
        // }));
        const rawParttypes = response.data?.partType;

        let partTypeData = [];

        if (Array.isArray(rawParttypes)) {
            partTypeData = rawParttypes.map((part) => ({
                value: part.id,
                label: part.data,
            }));
        } else if (rawParttypes && typeof rawParttypes === "object") {
            // Convert object values to array
            partTypeData = [rawParttypes].map((part) => ({
                value: part.id,
                label: part.data,
            }));
        }
        return partTypeData; // ✅ Return only the data
    } catch (error) {
        console.error("Error fetching Makes:", error);

        // ✅ Handle errors properly
        return (error.response?.data?.message || "error in fetching Part Type list");
    }
}
// export const getProductDataAPi = createAsyncThunk("/lookup=product", async (data) => {
//   try {
//     const response = await axios.get(
//       `https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=product&year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}&id=VAP0204`
//     );
//     console.log(`https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=product&year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}&id=VAP0204`)
//     console.log(" this is product resp  resonse ", response);
//     const jsonData = parser.parse(response.data);
//     console.log(" this is product jsonData  ", jsonData);
//     return jsonData;
//   } catch (error) {
//     throw error;
//   }
// });

// part data api
export const getEngineDataAPi = async (data) => {

    // try {
    //     const response = await externalFetcher(
    //         `https://www.showmethepartsdb2.com/bin/ShowMeConnect.EXE?lookup=engine&year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}&product=${data.selectedCategory}&id=VAP0204`
    //     );
    //     console.log(
    //         "url",
    //         `https://www.showmethepartsdb2.com/bin/ShowMeConnect.EXE?lookup=engine&year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}&product=${data.selectedCategory}&id=VAP0204`
    //     );
    //     console.log(" this is part resp  resonse ", response);

    //     const jsonData = parser.parse(response);
    //     console.log(" this is part jsonData  ", jsonData);
    //     return jsonData;
    // } catch (error) {
    //     throw error;
    // }
    const token = localStorage.getItem("authToken");
    let url = `${baseUrl}vancouverapis/admin/showmetheparts/api/v1/get-engine?lookup=engine&year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}&product=${data.selectedCategory}`
    try {
        const response = await axios.get(url, {
            headers: {
                "auth-token": token,
            },
        });
        // const engineData = response.data?.allEngine.map((engine) => ({
        //     value: engine.id,
        //     label: engine.data,
        // }));
        const rawEngines = response.data?.allEngine;

        let engineData = [];

        if (Array.isArray(rawEngines)) {
            engineData = rawEngines.map((engine) => ({
                value: engine.id,
                label: engine.data,
            }));
        } else if (rawEngines && typeof rawEngines === "object") {
            // Convert object values to array
            engineData = [rawEngines].map((engine) => ({
                value: engine.id,
                label: engine.data,
            }));
        }
        return engineData; // ✅ Return only the data
    } catch (error) {
        console.error("Error fetching Makes:", error);

        // ✅ Handle errors properly
        return (error.response?.data?.message || "error in fetching Part Type list");
    }
}

// get part type

// export const getPartTypeApi = createAsyncThunk("/lookup=parttype", async (data) => {
//     try {
//         const response = await externalFetcher(
//             `https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=parttype&engine=${data?.selectedEngine}&year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}&product=${data.selectedProduct}&id=VAP0204`
//         );
//         // console.log(
//         //   "eurl",
//         //   `https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=parttype&engine=${data?.selectedEngine}&year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}&product=${data.selectedProduct}&id=VAP0204`
//         // );
//         console.log(" this is part resp  resonse ", response);

//         const jsonData = parser.parse(response);
//         console.log(" this is part type  jsonData  ", jsonData);
//         return jsonData;
//     } catch (error) {
//         throw error;
//     }
// });

// get part list
export const getPartListDataAPi = createAsyncThunk("/lookup=partlist", async (data, { rejectWithValue }) => {
    try {
        // let url = `https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=parts`;
        let url = `${baseUrl}vancouverapis/admin/showmetheparts/api/v1/get-part?lookup=parts`

        // Append engine first if it exists (to match real URL structure)
        if (data.selectedEngine) {
            url += `&engine=${data.selectedEngine}`;
        }

        // Maintain the correct order
        url += `&year=${data.selectedYear}`;
        url += `&make=${data.selectedMake}`;
        url += `&model=${data.selectedModel}`;
        // url += `&parttype=${data.selectedPartType}`;

        if (data.selectedPartType) {
            url += `&product=${data.selectedPartType}`;
        }

        // Use the actual ID you showed in working example
        //url += `&id=VAP0204`; // You can make this dynamic too

        // console.log("URL", url);
        const token = localStorage.getItem("authToken");

        try {
            const response = await axios.post(url, {
                headers: {
                    "auth-token": token,
                },
            });
            // console.log("sub Part Types cart product count response ", response);
            if (response.data.allParts)
                return response.data; // ✅ Return only the data

        } catch (error) {
            console.error("Error fetching products:", error);

            // ✅ Handle errors properly
            return rejectWithValue(error.response?.data?.message || "error in fetching products list");
        }

        // const response = await externalFetcher(url);
        // console.log("Part list response: ", response);

        // const jsonData = parser.parse(response);
        // console.log("Parsed JSON data: ", jsonData);

        // return jsonData;
    } catch (error) {
        console.error("Error fetching part list:", error);
        throw error;
    }
});

// get part list by id
export const getPartListByIdDataAPi = async (data) => {
    //   try {
    //     const response = await externalFetcher(`https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=partdetailfull&part=${data}&id=VAP0204`);

    //     console.log(" this is single product  resp  resonse ", response);
    //     const jsonData = parser.parse(response);
    //     console.log(" this is single product jsonData  ", jsonData);

    //     return jsonData;
    //   } catch (error) {
    //     throw error;
    //   }
    const token = localStorage.getItem("authToken");
    // let url = `${baseUrl}vancouverapis/admin/showmetheparts/api/v1/get-part?year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}`
    let url = `${baseUrl}vancouverapis/admin/showmetheparts/api/v1/get-partDetails?part=${data}`
    try {
        const response = await axios.get(url, {
            headers: {
                "auth-token": token,
            },
        });
        console.log(" this is single product  resp  resonse ", response.data);
        return response.data.partDetails;
    } catch (error) {
        console.error("Error fetching Makes:", error);

        // ✅ Handle errors properly
        return (error.response?.data?.message || "error in fetching Part details for single product");
    }
}

//For getting part list by PartNO
export const getPartsByPartNo = async (partNo) => {
    const token = localStorage.getItem("authToken");
    // let url = `${baseUrl}vancouverapis/admin/showmetheparts/api/v1/get-part?year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}`
    let url = `${baseUrl}vancouverapis/admin/showmetheparts/api/v1/get-part-details?partno=${partNo}`
    try {
        const response = await axios.post(url, {
            headers: {
                "auth-token": token,
            },
        });
        console.log(" partNosearhc", response.data);
        return response; // ✅ Return only the data
    } catch (error) {
        console.error("Error fetching Makes:", error);

        // ✅ Handle errors properly
        return (error.response?.data?.message || "error in fetching Part details by Part no");
    }
}

//For getting Related Products  - cross reference parts
export const getCrossReferenceParts = async (partNo) => {
    const token = localStorage.getItem("authToken");
    // let url = `${baseUrl}vancouverapis/admin/showmetheparts/api/v1/get-part?year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}`
    let url = `${baseUrl}vancouverapis/admin/showmetheparts/api/v1/get-cross-refence?compno=${partNo}`
    try {
        const response = await axios.post(url, {
            headers: {
                "auth-token": token,
            },
        });
        console.log(" partNosearhc", response.data);
        return response; // ✅ Return only the data
    } catch (error) {
        console.error("Error fetching Makes:", error);

        // ✅ Handle errors properly
        return (error.response?.data?.message || "error in fetching Part details by Part no");
    }
}

// get part data by partno
export const getPartDataWithPartNOApi = createAsyncThunk("/lookup=partlist&partno", async (data) => {
    try {
        const response = await externalFetcher(`https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=partlist&partno=${data}&id=VAP0204`, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        console.log(" this is part data by partno  resp  resonse ", response);
        const jsonData = parser.parse(response);
        console.log(" this is part data by partno jsonData  ", jsonData);
        return jsonData;
    } catch (error) {
        throw error;
    }
});

// realted prdoucts on the single page product

export const getRelatedProudctOnSinglePage = createAsyncThunk("/lookup=complist", async (data) => {
    try {
        const response = await externalFetcher(`https://www.showmethepartsdb2.com/bin/ShowMeconnect.exe?lookup=complist&compno=${data}&id=VAP0204`, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        console.log(" realted product  resonse ", response);
        const jsonData = parser.parse(response);
        console.log(" realted product response jsonData  ", jsonData);
        return jsonData;
    } catch (error) {
        throw error;
    }
});
